import './components/share'

import './scss/st1/styles.scss'
